/**
 * Plain textarea for new / plain values; the app's rich-text editor (jodit `TextEditorField`)
 * inside the wide-field frame when the loaded value already contains HTML (plan 6.E / 6.F:
 * `event_internal_notes` and `event_description` are rich text on the old pages — existing
 * content is preserved, new content is plain text).
 *
 * The mode is decided once, when the field mounts (sections mount after hydration), so typing a
 * `<` in the textarea never swaps the control under the user's cursor.
 * `TextEditorField` is uncontrolled after mount (shouldComponentUpdate → false) and reports on blur.
 */

import React, { useState } from "react";
import TextEditor from "../../../Components/Common/TextEditorField";

const HTML_RE = /<[a-z][\s\S]*>/i;
export const looksLikeHtml = (value) => HTML_RE.test(String(value || ""));

const RichOrPlainText = ({ value, onChange, placeholder, id, ariaLabel }) => {
  const [rich] = useState(() => looksLikeHtml(value));
  if (rich) {
    return (
      <div className="eb-editor-frame" id={id}>
        <TextEditor value={value} onChange={(html) => onChange(html)} />
      </div>
    );
  }
  return (
    <textarea
      id={id}
      value={value || ""}
      placeholder={placeholder}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default RichOrPlainText;
